module.exports = __webpack_public_path__ + "static/project-16db96297d69e636f504945abe921252.svg";